export const TAB_SWITCHER_TEST_ID = 'TabSwitcher';
export const TAB_OVERVIEW_INPUT_TEST_ID = 'TabOverviewInput';
export const TAB_JOURNEY_INPUT_TEST_ID = 'TabJourneyInput';
